import { FC } from "react"
import { Modal } from "@/ui/Modal"
import "./style.scss"

const modalType = "pageLoading"

export const Loader: FC = () => {
  return (
    <Modal.Center type={modalType}>
      <div className="loaderWrapper">
        <div className="loader" />
      </div>
    </Modal.Center>
  )
}
